/* eslint-disable no-unused-vars */
import { Outlet, Navigate } from 'react-router-dom';
import useAuth from '../hooks/useAuth';

const Anonymous = () => {
  const {
    auth, setAuth, persist, setPersist,
  } = useAuth();

  return (
    auth.accessToken ? <Navigate to="/spanel/home" /> : <Outlet />
  );
};

export default Anonymous;
